import { StoreItemCategory } from '../../entity_datas/StoreEnums.ts';
import { LobbyImage, StoreExpansionType } from '@colonist/types';
import { BaseStoreItem } from '../BaseStoreItem.ts';
export class SIExpansionClassic56P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.Classic56P, this.name = {
            key: 'strings:colonistCommon.gameModes.classic56P.title'
        }, this.description = 'strings:colonistCommon.gameModes.classic56P.description', this.price = 2800, this.image = LobbyImage.StoreItemExpansionClassic56P, this.activeInStore = true;
    }
}
export class SIExpansionClassic78P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.Classic78P, this.name = {
            key: 'strings:colonistCommon.gameModes.classic78P.title'
        }, this.description = 'strings:colonistCommon.gameModes.classic78P.description', this.price = 2800, this.image = LobbyImage.StoreItemExpansionClassic78P, this.activeInStore = true;
    }
}
export class SIExpansionSeafarers4P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.Seafarers4P, this.name = {
            key: 'strings:colonistCommon.gameModes.seafarers4P.title'
        }, this.description = 'strings:colonistCommon.gameModes.seafarers4P.description', this.price = 2800, this.image = LobbyImage.StoreItemSeafarers4P, this.activeInStore = true;
    }
}
export class SIExpansionSeafarers56P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.Seafarers56P, this.name = {
            key: 'strings:colonistCommon.gameModes.seafarers56P.title'
        }, this.description = 'strings:colonistCommon.gameModes.seafarers56P.description', this.price = 2800, this.image = LobbyImage.StoreItemSeafarers56P, this.activeInStore = true;
    }
}
export class SIExpansionCitiesAndKnights4P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.CitiesAndKnights4P, this.name = {
            key: 'strings:colonistCommon.gameModes.citiesAndKnights4P.title'
        }, this.description = 'strings:colonistCommon.gameModes.citiesAndKnights4P.description', this.price = 2800, this.image = LobbyImage.StoreItemCitiesAndKnights4P, this.activeInStore = true;
    }
}
export class SIExpansionCitiesAndKnights56P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.CitiesAndKnights56P, this.name = {
            key: 'strings:colonistCommon.gameModes.citiesAndKnights56P.title'
        }, this.description = 'strings:colonistCommon.gameModes.citiesAndKnights56P.description', this.price = 2800, this.image = LobbyImage.StoreItemCitiesAndKnights56P, this.activeInStore = true;
    }
}
export class SIExpansionCitiesAndKnightsSeafarers4P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.CitiesAndKnightsSeafarers4P, this.name = {
            key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.title'
        }, this.description = 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.description', this.price = 2800, this.image = LobbyImage.StoreItemCitiesAndKnightsSeafarers4P, this.activeInStore = true;
    }
}
export class SIExpansionCitiesAndKnightsSeafarers56P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.CitiesAndKnightsSeafarers56P, this.name = {
            key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.title'
        }, this.description = 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.description', this.price = 2800, this.image = LobbyImage.StoreItemCitiesAndKnightsSeafarers56P, this.activeInStore = true;
    }
}
export class SIExpansionTradersAndBarbarians extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.TradersAndBarbarians, this.name = {
            key: 'strings:colonistCommon.gameModes.tradersAndBarbarians.title'
        }, this.description = 'strings:colonistCommon.gameModes.tradersAndBarbarians.description', this.price = 2800, this.image = LobbyImage.XMark;
    }
}
export class SIExpansionExplorersAndPirates extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.ExplorersAndPirates, this.name = {
            key: 'strings:colonistCommon.gameModes.explorersAndPirates.title'
        }, this.description = 'strings:colonistCommon.gameModes.explorersAndPirates.description', this.price = 2800, this.image = LobbyImage.XMark;
    }
}
export class SIExpansionColonistRush4P extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Expansion, this.type = StoreExpansionType.ColonistRush4P, this.name = {
            key: 'strings:colonistCommon.gameModes.colonistRush.title'
        }, this.description = 'strings:colonistCommon.gameModes.colonistRush.description', this.price = 2800, this.image = LobbyImage.GameModeColonistRush, this.activeInStore = true;
    }
}
